<template>
	<div class="dashboard-card">
		<apex-chart :options="options" :series="series" />
	</div>
</template>

<script>
import ApexChart from 'vue-apexcharts'
import { NO_CALL_TYPE } from '@/config/constants'
/**
 * The default chart options.
 *
 * @return {Object}
 */
const getDefaultChartOptions = () => {
	return {
		chart: {
			type: 'bar',
			stacked: true,
		},
		colors: ['#f7992b', '#2b6cb0'],
		plotOptions: {
			bar: {
				columnWidth: '30%',
				endingShape: 'rounded',
				horizontal: false,
			},
		},
		stroke: {
			width: 1,
			colors: ['#fff'],
		},
		title: {
			text: 'Message Volume by Call Type',
			style: {
				fontFamily: 'Roboto',
			},
		},
		subtitle: {
			text: 'Last 30 days',
			align: 'left',
			style: {
				fontSize: '12px',
				fontWeight: 'normal',
				fontFamily: 'Roboto',
				color: '#9699a2',
			},
		},
		xaxis: {
			categories: [],
			labels: {
				rotate: -90,
			},
			style: {
				fontFamily: 'Roboto',
			},
		},
		fill: {
			opacity: 1,
		},
		legend: {
			position: 'top',
			horizontalAlign: 'left',
			offsetX: 40,
		},
	}
}

export default {
	/**
	 * The component's registered child components.
	 *
	 * @type {Object}
	 */
	components: {
		ApexChart,
	},

	/**
	 * The component's computed properties.
	 *
	 * @type {Object}
	 */
	computed: {
		/**
		 * Get the chart categories to be displayed.
		 *
		 * @return {Array}
		 */
		categories() {
			if (!this.types) {
				return []
			}

			return this.types.map(type => type.label || NO_CALL_TYPE)
		},

		/**
		 * Get the chart's options.
		 *
		 * @return {Object}
		 */
		options() {
			const options = getDefaultChartOptions()

			if (this.title) {
				options.subtitle.text = this.title
			}

			options.xaxis.categories = this.categories

			return options
		},

		/**
		 * Get the chart's data to display.
		 *
		 * @return {Array}
		 */
		series() {
			if (!this.types) {
				return []
			}

			return [
				{
					name: 'Urgent',
					data: this.types.map(type => type.urgent_count),
				},
				{
					name: 'Non-Urgent',
					data: this.types.map(type => type.non_urgent_count),
				},
			]
		},
	},

	/**
	 * The component's name used for debugging.
	 *
	 * @type {String}
	 */
	name: 'TypeChart',

	/**
	 * The component's inherited properties.
	 *
	 * @type {Object}
	 */
	props: {
		/**
		 * The chart's title.
		 *
		 * @type {String}
		 */
		title: {
			type: String,
			required: false,
		},

		/**
		 * The call types information to be displayed.
		 *
		 * @type {Array}
		 */
		types: {
			type: Array,
			required: true,
		},
	},
}
</script>
